import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles<{ border?: string }>()(
  ({}, { border }) => ({
    root: {
      border: border,
    },
  }),
);
